<div id="digitalQuestionPage" *ngIf="question$ | async as questionInfo">

  <div class="row pad-t-6 pad-r-t-5 mar-b-10 mar-r-b-2">

    <div class="col-lg-7 d-flex justify-content-between pad-x-5 pad-r-x-2 stepperRow mar-r-b-3" *ngIf="questionInfo.currentLevel !== 0">
      <div class="step" (click)="questionInfo.currentLevel = 8"
        [ngClass]="{'currentUXStep': questionInfo.currentLevel === 8, 'activedUXStep': questionInfo.currentLevel > 8}">
        <div class="d-flex flex-column align-items-center">
          <div class="position-relative d-inline-block">
            <input type="radio" [checked]="questionInfo.currentLevel >= 8">
            <div class="stepperUXLine"></div>
          </div>
          <div class="stepperText d-none d-lg-block">
            {{ ('COMMON.LEVELS.BASIC') | translate }}
          </div>
        </div>
      </div>
      <div class="step" (click)="questionInfo.currentLevel = 9"
        [ngClass]="{'currentUXStep': questionInfo.currentLevel === 9, 'activedUXStep': questionInfo.currentLevel > 9}">
        <div class="d-flex flex-column align-items-center">
          <div class="position-relative d-inline-block">
            <input type="radio" [checked]="questionInfo.currentLevel >= 9">
            <div class="stepperUXLine"></div>
          </div>
          <div class="stepperText d-none d-lg-block">
            {{ ('COMMON.LEVELS.INTERMEDIATE') | translate }}
          </div>
        </div>
      </div>
      <div class="step" (click)="questionInfo.currentLevel = 10"
        [ngClass]="{'currentUXStep': questionInfo.currentLevel === 10, 'activedUXStep': questionInfo.currentLevel > 10}">
        <div class="d-flex flex-column align-items-center">
          <div class="position-relative d-inline-block">
            <input type="radio" [checked]="questionInfo.currentLevel >= 10">
            <div class="stepperUXLine"></div>
          </div>
          <div class="stepperText d-none d-lg-block">
            {{ ('COMMON.LEVELS.ADVANCED') | translate }}
          </div>
        </div>
      </div>
      <div class="step" (click)="questionInfo.currentLevel = 11"
        [ngClass]="{'currentUXStep': questionInfo.currentLevel === 11, 'activedUXStep': questionInfo.currentLevel > 11}">
        <div class="d-flex flex-column align-items-center">
          <div class="position-relative d-inline-block">
            <input type="radio" [checked]="questionInfo.currentLevel >= 11">
          </div>
          <div class="stepperText d-none d-lg-block">
            {{ ('COMMON.LEVELS.EXPERT') | translate }}
          </div>
        </div>
        </div>
    </div>
    
    <div class="offset-lg-1 col-lg-4 d-flex align-items-center time-row" *ngIf="timeSpent != null" >
      <div class="d-inline-block w-100 body-s">
        <div class="position-relative" style="margin-bottom: 5px;">
          <span *ngIf="(timeSpent * 100 / (questionInfo.maxLevelDuration/60)) < 100" [style]="'left:'+(timeSpent * 100 / (questionInfo.maxLevelDuration/60))+'%'">
            {{ (timeSpent <= 1 ? ('TEST.' + questionInfo.testModelId + '.MINUTESREMAINING.SINGULAR'): ('TEST.' + questionInfo.testModelId + '.MINUTESREMAINING.PLURAL'))  | translate: { minutes: timeSpent } }}
          </span>
          <ngb-progressbar
            [value]="(timeSpent * 100 / (questionInfo.maxLevelDuration/60))"
            [ngClass]="'custom-progress'"
            [ngStyle]="{'background-color': '#D7D7D7'}"
            height="15px"
          >
          </ngb-progressbar>
        </div>
        <div class="mar-t-1 d-flex justify-content-between">
          <p>{{ ('TEST.' + questionInfo.testModelId + '.QUESTIONPERTOTAL') | translate: { x:questionData.position, y:questionInfo.questionsInLevel} }}</p>
          <p>{{ (questionInfo.maxLevelDuration/60 <= 1 ? ('TEST.' + questionInfo.testModelId + '.MINUTESREMAINING.SINGULAR'): ('TEST.' + questionInfo.testModelId + '.MINUTESREMAINING.PLURAL'))  | translate: { minutes: questionInfo.maxLevelDuration/60 } }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="row body-l body-r-m">

    <div class="col-lg-10">
        <!-- <img src="/assets/images/digital/robot.png"> -->
        <div class="speechBubble question thinking animate__animated">
          <div class="dotLoader">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

        <div class="speechBubble question typewriter animate__animated animate__bounceIn"></div>

        <ng-container *ngFor="let option of questionData?.options; let i= index">
          <div class="questionOption mar-b-2">
            <input id="option{{i}}" type="radio" class="d-inline-flex justify-content-center align-items-center cursor-pointer" [value]=option.id [(ngModel)]="optionId">
            <label for="option{{i}}" class="mar-b-0 cursor-pointer">{{ option.description }}</label>
          </div>
        </ng-container>

        <button class="btn nextQuestionButton" (click)="setAnswer()" [disabled]="!optionId">
          {{ 'COMMON.NEXT' | translate }}
        </button>
    </div>

  </div>
</div>
